<template>
  <div class="bg-yellow-200 text-sm text-gray-800 mt-2 py-1 px-2 rounded-md tracking-tighter">
    Your account has been converted to our new email based login system. Please
    <button type="button" class="underline font-medium" @click="$emit('action')">
      {{ linkLabel }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    linkLabel: {
      type: String,
      default: 'Login with email'
    }
  },
  emits: ['action']
}
</script>
